import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { StatCard } from '../../../components/ui';
import { formatCurrency } from '../../../utils/baseUtils';

dayjs.extend(utc);

const ReferralStats = ({ data }) => {
  const hasBalance = (data?.availablebalance || 0) > 0;
  const expiresValue =
    hasBalance && data?.expiresindays != null
      ? `${data.expiresindays} ${data.expiresindays === 1 ? 'day' : 'days'}`
      : '—';
  const expiresHint = data?.nextexpiration
    ? `Next: ${dayjs.utc(data.nextexpiration).format('MMM D, YYYY')}`
    : undefined;

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      <StatCard
        label="Available Credit"
        value={formatCurrency(data?.availablebalance || 0)}
        hint={
          data?.totalexpired > 0
            ? `Expired: ${formatCurrency(data.totalexpired)}`
            : undefined
        }
      />
      <StatCard
        label="Total Earned"
        value={formatCurrency(data?.totalearned || 0)}
      />
      <StatCard
        label="Total Used"
        value={formatCurrency(data?.totalconsumed || 0)}
      />
      <StatCard label="Next Expiration" value={expiresValue} hint={expiresHint} />
    </div>
  );
};

export default ReferralStats;
